import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

import VueSweetalert2 from 'vue-sweetalert2';
// import 'sweetalert2/dist/sweetalert2.css';
Vue.use(VueSweetalert2);


import moment from 'moment'
Vue.prototype.$moment = moment

import {toMoney} from "@/components/helper/general.js"
Vue.prototype.$toMoney = toMoney

router.beforeEach(
  (to,from,next) => {
    store.commit("mutate", { prop: "pageTitle", data: to.meta.title })

    if(to.matched.some(record => record.meta.public)){
      if(store.state.token != ""){
        next({
          path: '/dashboard'
        })
      } else next()
    }

    else if(to.matched.some(record => record.meta.private)){
      if( store.state.token == ""){
        next({
          path: '/login'
        })
      } else next()
    }
    else next()
  }
)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
